import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import LabeledToggle from '../../shared/LabeledToggle';
import SectionTitle from '../../shared/SectionTitle';
import styles from './styles.scss';

const HourlyReadingChartSettings = ({ displayChart, includeTimeStamp, onChange }) => [
  <Row key="content">
    <Col className={`py-3 px-0 mx-3 ${styles.infoSection}`}>
      <div className={styles.dataBlock}>
        <SectionTitle title="Hourly Reading Chart Settings" />
      </div>
      <div className={styles.toggle}>
        <LabeledToggle
          label="Display Hourly Reading Chart"
          checked={displayChart}
          onChange={() => onChange('hourlyDisplayChart', !displayChart)}
        />
        {false && (
          <div>
            <LabeledToggle
              label="Include Timestamp on Hourly Reading Chart"
              checked={includeTimeStamp}
              onChange={() => onChange('includeTimeStamp', !includeTimeStamp)}
            />

            <a href="https://www.radstaralpha.com/knowledge-base/timestamps" className={styles.link}>
              [Click for more details](https://www.radstaralpha.com/knowledge-base/timestamps)
            </a>
          </div>
        )}
      </div>
    </Col>
  </Row>,
];

HourlyReadingChartSettings.propTypes = {
  displayChart: PropTypes.bool,
  includeTimestamp: PropTypes.bool,
  onChange: PropTypes.func,
};

export default HourlyReadingChartSettings;



// WEBPACK FOOTER //
// src/components/reportContentLayout/HourlyReadingChartSettings/index.jsx